// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import BrandLogo from 'components/atoms/BrandLogo';
import TopNavSupport from 'containers/LeftHandLayout/common/SupportMenu';
import TopNavUser from 'containers/LeftHandLayout/common/UserMenu';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import CopyButton from '@liquidweb-dev/undercurrent/CopyButton';
import useAccountDetails from 'modules/queries/account/useDetails';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';

const Suspended = () => {
	const {
		data: accountUserDetailsData,
		isLoading: isAccountUserDetailsLoading,
	} = useAccountDetails({});

	const accountNumber = accountUserDetailsData?.accnt;
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<BrandLogo />

			<Box sx={{ display: 'flex', alignItems: 'center', gap: 150 }}>
				{isAccountUserDetailsLoading ? (
					<Skeleton width={100} height={24} />
				) : (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 100,
							paddingX: 200,
						}}
					>
						<Typography variant="label-md" sx={{ fontWeight: 500 }}>
							Account # {accountNumber}
						</Typography>
						<CopyButton
							onClick={() => navigator.clipboard.writeText(accountNumber || '')}
							iconButtonProps={{ variant: 'barebones', size: 'small' }}
							tooltipProps={{ placement: 'bottom' }}
						/>
					</Box>
				)}
				<TopNavSupport />
				<TopNavUser />
			</Box>
		</Box>
	);
};

export default Suspended;
